import { MapPin, Clock, PartyPopper } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Eventos({ datos, seccion }) {
  const eventos = datos.eventos || [];
  if (eventos.length === 0) return null;

  return (
    <section className="ki-seccion" aria-label={seccion.titulo}>
      <div className="ki-seccion-interior">
        <EncabezadoSeccion p="ki" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="ki-titulo-eventos" />
        <div className="ki-eventos-lista">
          {eventos.map((ev, i) => (
            <Reveal key={ev.id || i} delay={i * 0.08}>
              <article className="ki-evento" data-testid={`ki-evento-${ev.id || i}`}>
                <span className="ki-evento-icono">
                  <PartyPopper strokeWidth={1.8} />
                </span>
                <p className="ki-evento-etiqueta">{ev.etiqueta}</p>
                <h3 className="ki-evento-nombre">{ev.lugar}</h3>
                <p className="ki-evento-detalle">
                  <Clock strokeWidth={2} />
                  <span>{ev.horario}</span>
                </p>
                <p className="ki-evento-detalle">
                  <MapPin strokeWidth={2} />
                  <span>{ev.direccion}</span>
                </p>
                {ev.urlUbicacion && (
                  <a
                    className="ki-boton"
                    href={ev.urlUbicacion}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`ki-boton-ubicacion-${ev.id || i}`}
                  >
                    <MapPin strokeWidth={2} />
                    {ev.textoBoton || "Cómo llegar"}
                  </a>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
